<script>import { PrxImageV2, Link, Iframe } from "../../index.js";
import {} from "../../../data-groceryserver/index.js";
import {} from "../../../types/index.js";
export let offer;
export let isInlineBIU = false;
export let onClickTelemetry = () => {
  noTracking();
};
export let isRmni = false;
export let siteClass = "";
let clickPixel;
let biuClickPixels = [];
const getClickPixel = (o) => o.promotionPixels.filter((pixel) => pixel.type === "click");
const handleCTAclick = () => {
  clickPixel = { ...getClickPixel(offer)[0] };
  if (Object.keys(clickPixel)) {
    addClickPixel(clickPixel);
  }
  onClickTelemetry(offer);
};
const addClickPixel = (clickPixel2) => {
  var l = biuClickPixels.length;
  biuClickPixels[l] = clickPixel2;
};
const noTracking = () => {
  console.warn(
    "BIU tracking not setup. Please provide a callback function for prop onClickTelemetry."
  );
};
</script>

<div
    id={`${offer.id}`}
    class={`branded-ingredient-unit`}
    class:branded-ingredient-unit--rmni={isRmni}
    class:branded-ingredient-unit--inline={isInlineBIU}
>
    <div class="branded-ingredient-unit__offer">
        <div class="offer__image">
            <PrxImageV2
                prxImageV2Props={{
                    src: offer.imageUrl,
                    altText: `Featured product: ${offer.heading}`,
                    titleText: `${offer.heading}`
                }}
            />
        </div>
        <div class="offer__details">
            <div class="details__header">Popular Picks</div>
            <div class="details__title" title={isRmni ? offer.heading : ''}>
                {offer.heading}
            </div>
            <div class="details__description">{offer.subHeading}</div>
            <!-- svelte-ignore a11y-no-static-element-interactions -->
            <div
                class="details__cta"
                on:click={handleCTAclick}
                on:keydown={handleCTAclick}
            >
                <Link
                    linkMarkup=""
                    linkText={offer.ctaText}
                    linkUrl={offer.ctaLink}
                    targetType="_blank"
                    classNames={`${siteClass} ${isInlineBIU ? 'link--biu-inline' : 'link--biu'}`}
                />
            </div>
            <div class="details__ad">ADVERTISEMENT</div>
            {#if offer.promotionPixels}
                <div class="details__pixel">
                    {#if !isInlineBIU}
                        {#each offer.promotionPixels.filter((px) => px.type === 'impression' || px.type === 'moat') as pixel, index}
                            <Iframe
                                url={pixel.url}
                                title="BIU impression"
                                width={1}
                                height={1}
                                iframeOnLoadHandler={()=>{}}>
                            </Iframe>
                        {/each}
                    {/if}
                    {#each biuClickPixels as pixel, index}
                        <img
                            src={pixel.url}
                            width="1"
                            height="1"
                            alt="biu-click-pixel"
                        />
                    {/each}
                </div>
            {/if}
        </div>
    </div>
</div>

<style>/* retailer-specific styles */
.branded-ingredient-unit__offer {
  display: flex;
  flex-direction: row;
  margin: 24px auto 0;
  padding: 0 0 16px;
}
.branded-ingredient-unit .offer__image {
  flex: 0 0 54px;
}
.branded-ingredient-unit .offer__details {
  display: flex;
  flex-direction: column;
  margin-left: 4px;
  font: 400 14px/20px "Arial", sans-serif;
  letter-spacing: normal;
}
.branded-ingredient-unit .details {
  font-family: var(--pol-theme-secondary-font-family);
  font-size: 14px;
  line-height: 20px;
}
.branded-ingredient-unit .details__header {
  display: none;
}
.branded-ingredient-unit .details__title {
  font-weight: 700;
}
.branded-ingredient-unit .details__cta {
  text-underline-offset: 3px;
  font-size: 11px;
  font-weight: 700;
}
.branded-ingredient-unit .details__ad {
  display: none;
}
.branded-ingredient-unit .details__pixel {
  display: none;
}
.branded-ingredient-unit--inline {
  margin: 16px 0;
}
.branded-ingredient-unit--inline .offer__details {
  width: auto;
}
.branded-ingredient-unit--inline .details__description {
  margin-top: 7px;
}
.branded-ingredient-unit--inline .details__cta {
  margin: 0;
  margin-top: 7px;
}
.branded-ingredient-unit--inline .details__ad {
  display: block;
  font-weight: 400;
  color: #b2b2b2;
  font-size: 0.61rem;
  margin-top: 7px;
  text-transform: uppercase;
}
.branded-ingredient-unit--rmni {
  display: flex;
  width: 192px;
  height: 160px;
}
.branded-ingredient-unit--rmni .details__title {
  overflow: hidden;
}
.branded-ingredient-unit--rmni .details__description {
  flex-grow: 1;
}</style>
